var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('div',{},[_c('Nav')],1),_c('div',{staticClass:"view"},[_c('keep-alive',{attrs:{"include":"Webdav"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }